var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "128.000000pt",
    height: "128.000000pt",
    viewBox: "0 0 128.000000 128.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,128.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63 1073 c-13 -2 -32 -16 -43 -30 -19 -25 -20 -40 -20 -404 l0 -378 24 -28 24 -28 592 0 592 0 24 28 24 28 0 379 0 379 -24 28 -24 28 -574 1 c-315 1 -583 0 -595 -3z m1165 -130 l3 -73 -591 0 -590 0 0 68 c0 38 3 72 7 75 3 4 268 6 587 5 l581 -3 3 -72z m0 -450 l-3 -228 -585 0 -585 0 -3 228 -2 227 590 0 590 0 -2 -227z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212 538 l3 -23 239 -3 c241 -2 272 2 259 34 -4 12 -48 14 -255 14 l-249 0 3 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213 445 c-11 -31 12 -36 153 -33 131 3 139 4 139 23 0 19 -8 20 -143 23 -123 2 -143 0 -149 -13z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.a20a95a9a07e75d3faba968cfe87f168.svg";
export { ForwardRef as ReactComponent };